import React from 'react';
import './App.css';
import Sweetroot from './components/Sweetroot.js'
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
import Auth from './components/Auth';
function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Router>
          <Switch>
            <Route path="/adm/ui/settings/config">
              <Auth></Auth>
            </Route>
            <Route path="/">
              <Sweetroot />
            </Route>
          </Switch>
        </Router>
      </header>
    </div>
  );
}
export default App;




